import { render } from "./VgWordView.vue?vue&type=template&id=7313b1ce"
import script from "./VgWordView.vue?vue&type=script&lang=js"
export * from "./VgWordView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__